import { Dimmer as DimmerBase } from '@packages/ui-kit/core/dimmer';
import { withStopPropagation } from '../../helpers/hocs/with-stop-propagation';

export const Dimmer = withStopPropagation('onClick')(DimmerBase);
